import { render, staticRenderFns } from "./ClinicContentModeration.vue?vue&type=template&id=67e53f52&scoped=true&"
import script from "./ClinicContentModeration.vue?vue&type=script&lang=js&"
export * from "./ClinicContentModeration.vue?vue&type=script&lang=js&"
import style0 from "./ClinicContentModeration.vue?vue&type=style&index=0&id=67e53f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e53f52",
  null
  
)

export default component.exports